import {
  GOOGLE,
  ADS_CAMPAIGN_TYPE_APP_OPTION,
} from "../../../../utils/constants";
import { useFormContext } from "react-hook-form";
import AdGroupSearchGoogleForm from "./AdGroupSearchGoogleForm";
import AdGroupAppGoogleForm from "./AdGroupAppGoogleForm";
import { useEffect, useState } from "react";
import { waitDelay } from "../../../../utils/date";

const AdGroupGoogleForm = () => {
  const [isLoading, setIsLoading] = useState(true);
  //To reset values component when change selectedLevel

  const { watch, sectionSelected } = useFormContext();
  const platformData = watch(`platformsData.${GOOGLE}`) || {};
  const objective = platformData?.objective;

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await waitDelay(1);
      setIsLoading(false);
    })();
  }, [sectionSelected]);

  if (isLoading) return null;

  if (objective === ADS_CAMPAIGN_TYPE_APP_OPTION) {
    return <AdGroupAppGoogleForm />;
  }

  // Default to search for backward compatibility
  return <AdGroupSearchGoogleForm />;
};

export default AdGroupGoogleForm;
